
import { Component, Vue } from 'vue-property-decorator';


@Component
export default class FillForm1HeaderInfo extends Vue {
   
    public displayResults(){
        this.$emit('displayResults');
    }
}
